import React, { Fragment } from "react";
import PropTypes from "prop-types";
import moment from "moment";

import Table from "../common/Table";
import TableRow from "../common/TableRow";
import TableData from "../common/TableData";
import Row from "../common/Row";
import { Popup } from 'semantic-ui-react';
import { WedstrijdverbandTypes } from "../../constants/DomainConstants";
import ConfirmModal from "../common/ConfirmModal";
import ArrowRightIcon from "../common/svg nado/ArrowRightIcon";
import GeneesmiddelComponent from "../shared/GeneesmiddelComponent";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faMinus, faTimes, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

const GeneesmiddelOverzichtForm = (props) => {
    const {
        onPageNoChange,
        onPageSizeChange,
        pagedGeneesmiddelen,
        onSortTable,
        detailModalOpen,
        detailModel,
        onClickShowDetail,
        onCancelShowDetail,
    } = props;

    const returnTdContent = (text) => {
        if (text)
            return text.length > 40 ? <Popup wide="very" position="top left" trigger={<p>{text.substring(0, 50) + "..."}</p>} content={text} /> : text;
    };

    const handleOnClickShowDetail = (id) => {
        return function (event) {
            onClickShowDetail(id, event);
        };
    };

    const capitalizeFirstLetter = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1);
    };

    //use this instead of replaceAll() for browser support
    const customReplaceAll = (string, a, b) => {
        return string.split(a).join(b);
    };

    const tdOrange = 'c-code  c-code__orange';
    const tdGreen = 'c-code';
    const tdRed = 'c-code  c-code__red';

    const geneesmiddelRows = pagedGeneesmiddelen.items.map((g) => {
        return g.stoffen.map((s, i) => {
            const binnenWedstrijdverbandIcon = s.binnenWedstrijdverband === WedstrijdverbandTypes.TOEGESTAAN ? faCheck : s.binnenWedstrijdverband === WedstrijdverbandTypes.VERBODEN ? faTimes : faMinus;
            const buitenWedstrijdverbandIcon = s.buitenWedstrijdverband === WedstrijdverbandTypes.TOEGESTAAN ? faCheck : s.buitenWedstrijdverband === WedstrijdverbandTypes.VERBODEN ? faTimes : faMinus;
            const binnenWedstrijdverbandClass = s.binnenWedstrijdverband === WedstrijdverbandTypes.TOEGESTAAN ? tdGreen : s.binnenWedstrijdverband === WedstrijdverbandTypes.VERBODEN ? tdRed : tdOrange;
            const buitenWedstrijdverbandClass = s.buitenWedstrijdverband === WedstrijdverbandTypes.TOEGESTAAN ? tdGreen : s.buitenWedstrijdverband === WedstrijdverbandTypes.VERBODEN ? tdRed : tdOrange;

            const binnenWedstrijdverbandIconClass = s.binnenWedstrijdverband === WedstrijdverbandTypes.TOEGESTAAN ? 'c-icon c-code__icon' : s.binnenWedstrijdverband === WedstrijdverbandTypes.VERBODEN ? 'c-icon c-code__icon c-icon__red' : 'c-icon c-code__icon c-icon__orange';
            const buitenWedstrijdverbandIconClass = s.buitenWedstrijdverband === WedstrijdverbandTypes.TOEGESTAAN ? 'c-icon c-code__icon' : s.buitenWedstrijdverband === WedstrijdverbandTypes.VERBODEN ? 'c-icon c-code__icon c-icon__red' : 'c-icon c-code__icon c-icon__orange';
            const binnenWedstrijdverbandTooltipTekst = Object.keys(WedstrijdverbandTypes).find(key => WedstrijdverbandTypes[key] === s.binnenWedstrijdverband);
            const buitenWedstrijdverbandTooltipTekst = Object.keys(WedstrijdverbandTypes).find(key => WedstrijdverbandTypes[key] === s.buitenWedstrijdverband);
            const binnenWedstrijdverbandTooltip = binnenWedstrijdverbandTooltipTekst ? capitalizeFirstLetter(customReplaceAll(customReplaceAll(binnenWedstrijdverbandTooltipTekst.toString().toLowerCase(), '_', ' '), '$', '/')) : "";
            const buitenWedstrijdverbandTooltip = buitenWedstrijdverbandTooltipTekst ? capitalizeFirstLetter(customReplaceAll(customReplaceAll(buitenWedstrijdverbandTooltipTekst.toString().toLowerCase(), '_', ' '), '$', '/')) : "";
            return (
                <TableRow key={`${g.id}_${s.id}_${i}`}>
                    <TableData >{i === 0 ? returnTdContent(g.naam) : null}</TableData>
                    <TableData>{s.heeftOpmerking && s.heeftOpmerking.toString() === "true" ?
                        <div>
                            <span
                                className="c-icon c-code__icon c-icon__yellow"
                                aria-hidden="true"
                                focusable="false"
                            ><FontAwesomeIcon icon={faExclamationTriangle} />
                            </span>
                        </div>
                        : <p>&nbsp;&nbsp;&nbsp;&nbsp;</p>}
                    </TableData>
                    <TableData responsive >{returnTdContent(s.naam)}</TableData>
                    <TableData responsive >{i === 0 && g.datumUitHandel ? moment(g.datumUitHandel).format("DD/MM/YYYY") : null}</TableData>
                    <TableData classNames="u-display:none@to:viewport-7">
                        <Popup trigger={
                            <div className={binnenWedstrijdverbandClass}>
                                <span
                                    className={binnenWedstrijdverbandIconClass}
                                    aria-hidden="true"
                                    focusable="false"
                                >
                                    <FontAwesomeIcon icon={binnenWedstrijdverbandIcon} />
                                </span>
                            </div>}
                            content={binnenWedstrijdverbandTooltip} />
                    </TableData>
                    <TableData classNames="u-display:none@to:viewport-7" >
                        <Popup trigger={
                            <div className={buitenWedstrijdverbandClass}>
                                <span
                                    className={buitenWedstrijdverbandIconClass}
                                    aria-hidden="true"
                                    focusable="false"
                                >
                                    <FontAwesomeIcon icon={buitenWedstrijdverbandIcon} />
                                </span>
                            </div>}
                            content={buitenWedstrijdverbandTooltip} />
                    </TableData>
                    <TableData classNames="u-display:none@at:viewport-7" >
                        <Popup trigger={
                            <div className={binnenWedstrijdverbandClass}>
                                <span
                                    className={binnenWedstrijdverbandIconClass}
                                    aria-hidden="true"
                                    focusable="false"
                                >
                                    <FontAwesomeIcon icon={binnenWedstrijdverbandIcon} />
                                </span>
                            </div>}
                            content={'Binnen wedstrijdverband: ' + binnenWedstrijdverbandTooltip} />
                                &nbsp;/&nbsp;
                                <Popup trigger={
                            <div className={buitenWedstrijdverbandClass}>
                                <span
                                    className={buitenWedstrijdverbandIconClass}
                                    aria-hidden="true"
                                    focusable="false"
                                >
                                    <FontAwesomeIcon icon={buitenWedstrijdverbandIcon} />
                                </span>
                            </div>}
                            content={'Buiten wedstrijdverband: ' + buitenWedstrijdverbandTooltip} />
                    </TableData>
                    <TableData>{i === 0 ?
                        <a className="c-link c-table-row__link" onClick={handleOnClickShowDetail(g.id)}>
                            <span className="c-link__text u-display:none@to:viewport-7">Lees meer</span>
                            <Popup trigger={
                                <span className="c-icon c-link__icon c-link__icon--after" aria-hidden="true" focusable="false">
                                    <ArrowRightIcon />
                                </span>} content={'Lees meer'} />
                        </ a>
                        : null}</TableData>
                </TableRow >);
        });
    });

    const mainTextDetailModal = <GeneesmiddelComponent
        model={detailModel}
        onCancel={onCancelShowDetail}
    />;

    return <Fragment>
        {detailModalOpen && <ConfirmModal
            showOnTop
            isOpen={detailModalOpen}
            mainText={mainTextDetailModal}
        />}
        {geneesmiddelRows && geneesmiddelRows.length ?
            <Row style={{ width: 'auto', display: "table", marginLeft: 'auto', marginRight: 'auto' }}>
                <Row><br /></Row>
                <Row style={{ width: 'auto', display: "table" }}><p>{moment().format("DD/MM/YYYY")}</p></Row>
                <Table
                    columnIndexesToHideWhenResponsive={[2, 3]}
                    id={"GeneesmiddelenTable"}
                    headers={[
                        "Naam",
                        "",
                        "Bevat",
                        "Uit de handel",
                        { text: "Binnen wedstrijdverband", className: 'u-display:none@to:viewport-7' },
                        { text: "Buiten wedstrijdverband", className: 'u-display:none@to:viewport-7' },
                        { text: "Wedstrijdverband: binnen / buiten", className: 'u-display:none@at:viewport-7' },
                        ""]}
                    headerSizes={[16, { size: 3, smallSize: 3 }, 16, 10, { size: 14, smallSize: 0 }, { size: 14, smallSize: 0 }, 20, { size: 20, smallSize: 6 }]}
                    activePage={pagedGeneesmiddelen.pageNo}
                    pageSize={pagedGeneesmiddelen.pageSize}
                    totalPages={pagedGeneesmiddelen.totalPages}
                    onPageChange={onPageNoChange}
                    totalItems={pagedGeneesmiddelen.totalItems}
                    sortableColumns={[0]}
                    changePageSize={onPageSizeChange}
                    narrowHeaders
                    onClickHeader={onSortTable}
                    title={"Lijst geneesmiddelen - " + pagedGeneesmiddelen.totalItems + " resultaten"}
                    centeredColumns={[4, 5]}
                >
                    {geneesmiddelRows}
                </Table>
            </Row>
            :
            <Row>
                <p className="leftMargin">Er zijn geen geneesmiddelen gevonden<br /><br /> <br /></p>
            </Row>
        }
    </Fragment >;
};

GeneesmiddelOverzichtForm.propTypes = {
    onPageNoChange: PropTypes.func,
    pagedGeneesmiddelen: PropTypes.object,
    onPageSizeChange: PropTypes.func,
    onSortTable: PropTypes.func,
    onSelectSearchOption: PropTypes.func,
    detailModalOpen: PropTypes.bool,
    onClickShowDetail: PropTypes.func,
    onCancelShowDetail: PropTypes.func,
    detailModel: PropTypes.object
};

export default GeneesmiddelOverzichtForm;